import { Editor } from '@toast-ui/editor';

document.addEventListener('DOMContentLoaded', () => {
	const textareas = document.querySelectorAll('textarea.wysiwyg');

	textareas.forEach((textarea) => {
		const mdTextarea = textarea as HTMLTextAreaElement;

		// Create markdown div
		const markdownDiv = document.createElement('div')
		mdTextarea.parentNode.insertBefore(markdownDiv, mdTextarea)

		// Initialize Toast UI Editor
		const editor = new Editor({
			usageStatistics: false,
			el: markdownDiv,
			initialValue: mdTextarea.value,
			previewStyle: 'tab',
			height: '400px',
			initialEditType: 'wysiwyg',
			toolbarItems: [
				['bold', 'italic', 'strike'],
				['link', 'quote', 'ul', 'ol', 'outdent', 'indent'],
				['table', 'hr', 'heading', 'code']
			]
		});

		// Sync Toast UI content with the hidden input (if needed)
		editor.on('change', () => {
			mdTextarea.value = editor.getMarkdown();
		});
	});
});
